/* ML-07 · BULK APPLY & OVERRIDES
   Before/after per establishment, approved local overrides preserved, every
   change carrying its inheritance source and a reversible version entry. */
import { Button, Card, ListRow, Pill } from '@/ui'
import { useML } from './EtabShell'

export default function ML07Appliquer() {
  const a = useML().apply
  return (
    <section data-frame="ML-07" style={{ display: 'grid', gap: 14 }}>
      <h2 className="t-section">{a.title}</h2>
      <Card>
        <strong>Avant / après par établissement :</strong> {a.inheritance}
      </Card>
      <ListRow title={a.exception.title} meta={a.exception.meta}
        end={<Pill tone={a.exception.status.tone} mark={a.exception.status.mark}>{a.exception.status.label}</Pill>} />
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
        <Button variant="primary" size="sm">Appliquer avec aperçu</Button>
        <Button variant="quiet" size="sm">Annuler</Button>
      </div>
      <p className="t-body">
        Chaque changement affiche sa source d’héritage, les établissements touchés et une entrée
        de version réversible.
      </p>
    </section>
  )
}
